module.exports = __webpack_public_path__ + "static/media/fixed_cost_project.ce3e19ba.svg";